import React, { useEffect } from 'react';
import { ErrorText } from 'components/atoms/Texts/ErrorText';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { capture } from 'services/sentry/capture';
import useStyle from './errorContainer.style';
import toast from 'react-hot-toast';
import { refreshPage } from 'helpers/page/refreshPage';

export interface ErrorContainerProps {
  text?: string;
  onClick?: (any) => void;
  detailErr?: Error;
  setFeedback?: boolean;
  hideButton?: boolean;
  marginTop?: boolean;
  needCaptureError?: boolean;
}

export const ErrorContainer = ({
  text,
  onClick,
  detailErr,
  setFeedback,
  hideButton = false,
  marginTop = false,
  needCaptureError = true
}: ErrorContainerProps) => {
  const classes = useStyle();
  useEffect(() => {
    const sendErr = () => {
      let err;
      if (detailErr) {
        err = detailErr;
      } else {
        err = text || "Pas d'informations supplémentaire";
      }
      needCaptureError && capture(err, [{ key: 'Details', extra: detailErr }]);
      setFeedback && toast.error(detailErr.message || text);
    };
    detailErr && sendErr();
    return () => {
      //DO NOTHING
    };
  });

  const reload = () => refreshPage();

  return (
    <div className={marginTop && classes.root}>
      <FeatureContainer>
        <ErrorText
          text={text || (detailErr && detailErr.message) || 'Erreur...'}
        />
        {!hideButton && (
          <ButtonWithText
            onClick={onClick ? onClick : reload}
            content="Recharger la page"
          />
        )}
      </FeatureContainer>
    </div>
  );
};
